export const ME_USER_DIALOG = 'ME_USER_DIALOG';
export const ME_PASSWORD_DIALOG = 'ME_PASSWORD_DIALOG';
export const CREATE_USER_DIALOG = 'CREATE_USER_DIALOG';
export const UPDATE_USER_DIALOG = 'UPDATE_USER_DIALOG';
export const CREATE_COMPANY_DIALOG = 'CREATE_COMPANY_DIALOG';
export const UPDATE_COMPANY_DIALOG = 'UPDATE_COMPANY_DIALOG';
export const CREATE_CONTAINER_DIALOG = 'CREATE_CONTAINER_DIALOG';
export const UPDATE_CONTAINER_DIALOG = 'UPDATE_CONTAINER_DIALOG';
export const SEARCH_CONTAINER_DIALOG = 'SEARCH_CONTAINER_DIALOG';
export const CREATE_TYPE_DIALOG = 'CREATE_TYPE_DIALOG';
export const UPDATE_TYPE_DIALOG = 'UPDATE_TYPE_DIALOG';
export const CREATE_TYPE_WITH_LIMIT_DIALOG = 'CREATE_TYPE_WITH_LIMIT_DIALOG';
export const UPDATE_TYPE_WITH_LIMIT_DIALOG = 'UPDATE_TYPE_WITH_LIMIT_DIALOG';
export const CREATE_TYPE_WITH_FIELDS_DIALOG = 'CREATE_TYPE_WITH_FIELDS_DIALOG';
export const UPDATE_TYPE_WITH_FIELDS_DIALOG = 'UPDATE_TYPE_WITH_FIELDS_DIALOG';
export const CREATE_CATEGORY_DIALOG = 'CREATE_CATEGORY_DIALOG';
export const UPDATE_CATEGORY_DIALOG = 'UPDATE_CATEGORY_DIALOG';
export const CREATE_CATEGORY_WITH_LIMIT_DIALOG = 'CREATE_CATEGORY_WITH_LIMIT_DIALOG';
export const UPDATE_CATEGORY_WITH_LIMIT_DIALOG = 'UPDATE_CATEGORY_WITH_LIMIT_DIALOG';
export const CREATE_GENRE_DIALOG = 'CREATE_GENRE_DIALOG';
export const UPDATE_GENRE_DIALOG = 'UPDATE_GENRE_DIALOG';
export const CREATE_FORMAT_DIALOG = 'CREATE_FORMAT_DIALOG';
export const UPDATE_FORMAT_DIALOG = 'UPDATE_FORMAT_DIALOG';
export const CREATE_PRICERANGE_DIALOG = 'CREATE_PRICERANGE_DIALOG';
export const UPDATE_PRICERANGE_DIALOG = 'UPDATE_PRICERANGE_DIALOG';
export const CREATE_BUSINESS_DIALOG = 'CREATE_BUSINESS_DIALOG';
export const UPDATE_BUSINESS_DIALOG = 'UPDATE_BUSINESS_DIALOG';
export const CREATE_AREA_DIALOG = 'CREATE_AREA_DIALOG';
export const UPDATE_AREA_DIALOG = 'UPDATE_AREA_DIALOG';
export const CREATE_STORE_DIALOG = 'CREATE_STORE_DIALOG';
export const UPDATE_STORE_DIALOG = 'UPDATE_STORE_DIALOG';
export const CREATE_LOCATION_DIALOG = 'CREATE_LOCATION_DIALOG';
export const UPDATE_LOCATION_DIALOG = 'UPDATE_LOCATION_DIALOG';
export const CREATE_RECEPTION_DIALOG = 'CREATE_RECEPTION_DIALOG';
export const UPDATE_RECEPTION_DIALOG = 'UPDATE_RECEPTION_DIALOG';
export const CREATE_RECEPTION_ORDER_DIALOG = 'CREATE_RECEPTION_ORDER_DIALOG';
export const UPDATE_RECEPTION_ORDER_DIALOG = 'UPDATE_RECEPTION_ORDER_DIALOG';
export const CREATE_PRODUCT_ATTRIBUTE_DIALOG = 'CREATE_PRODUCT_ATTRIBUTE_DIALOG';
export const UPDATE_PRODUCT_ATTRIBUTE_DIALOG = 'UPDATE_PRODUCT_ATTRIBUTE_DIALOG';